import { render } from "./ReferralSourcesDescription.vue?vue&type=template&id=0457be60&scoped=true"
import script from "./ReferralSourcesDescription.vue?vue&type=script&lang=js"
export * from "./ReferralSourcesDescription.vue?vue&type=script&lang=js"

import "./ReferralSourcesDescription.vue?vue&type=style&index=0&id=0457be60&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0457be60"]])

export default __exports__